export function calculateNetSaleValue(fee: number, saleValue: number) {
  const feeValue = (saleValue * fee) / 100

  return saleValue - feeValue
}
